<template>
  <v-app id="inspire" class="background-svg" :style="backgroundStyle">
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs11 sm6 md4>
            <v-card class="elevation-12 pb-10 px-4 pt-5" min-width="400">
              <v-card-title
                class="text-center d-flex flex-column justify-center"
              >
                <div class="justify-center">
                  <v-img
                    :src="API_BASE_URL + '/web_front/icon_logo.svg'"
                    class="logo-svg"
                  ></v-img>
                </div>
                <br />
                <div>
                  <span>Login</span>
                </div>
              </v-card-title>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="user.mobileNo"
                    name="mobileNo"
                    label="Mobile No"
                    outlined
                    dense
                    type="text"
                    readonly
                  ></v-text-field>
                  <v-text-field
                    v-model="user.otp"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    label="OTP"
                    @click:append="showPassword = !showPassword"
                    name="otp"
                    outlined
                    dense
                    v-validate="'required'"
                    :error="
                      errors.first('otp') != null ||
                        serverSideErrors.otp != null
                    "
                    :error-messages="
                      errors.first('otp') || serverSideErrors.otp
                    "
                  ></v-text-field>
                  
                </v-form>
              </v-card-text>
              <v-row>
                <v-col cols="12" class="px-6">
                  <v-btn
                    block
                    color="primary"
                    @click="login"
                    :loading="loading"
                  >
                    Verify OTP
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-flex>
          <Alert />
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Alert from "../../Alert.vue";
import "@/assets/style.css";
import { mapMutations } from "vuex";

export default {
  components: {
    Alert,
  },
  data() {
    return {
      showPassword: false, 
      user: {
        mobileNo: "",
        otp: "",
      },
      remember: false,
      loading: false,
      serverSideErrors: {},
    };
  },computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${process.env.VUE_APP_API_URL}/web_front/bulding.svg)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center' ,
        height: '100vh' ,
      };
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    login() {
      let _self = this;

      this.$validator.validateAll().then((result) => {
        if (result) {
          _self.loading = true;

          _self.$axios
            .post("/societyadmin/verifyOtp", this.user)
            .then((response) => {
              let data = response.data;
              _self.loading = false;

              if (data.status) {
                localStorage.setItem("user", JSON.stringify(data.society));
                _self.$axios.defaults.headers.common = {
                  Authorization: "Bearer " + data.society.token,
                };
                _self.$vuetify.theme.themes.light.primary =
                  data.society.theme_primary_color;
                _self.$vuetify.theme.themes.dark.primary =
                  data.society.theme_primary_color;
                _self.$vuetify.theme.themes.light.secondary =
                  data.society.theme_button_color;
                _self.$vuetify.theme.themes.dark.secondary =
                  data.society.theme_button_color;
                _self.$router.push({ path: "/societyadmin/dashboard/" });

                this.setAlert({
                  showAlert: true,
                  variant: "green accent-4",
                  timeout: "2000",
                  message: data.message,
                });
              } else {
                if (data.errors) {
                  _self.serverSideErrors = {};

                  for (let i = 0; i < data.errors.length; i++) {
                    _self.serverSideErrors[data.errors[i].field] =
                      data.errors[i].message;
                  }
                } else {
                  this.setAlert({
                    showAlert: true,
                    variant: "red accent-3",
                    timeout: "2000",
                    message: data.message,
                  });
                }
              }
            });
          return;
        }
      });
    },
  },
  mounted() {
    let mobileNo = this.$route?.params?.mobileNo;

    if (!mobileNo) {
      this.$router.push({ path: "/societyadmin/login" });
    }

    this.user.mobileNo = mobileNo;
  },
};
</script>

<style scoped>


.logo-svg {
  width: 150px !important;
}
</style>
